module.exports = __webpack_public_path__ + "static/media/display-alt.29ece0dd.svg";